import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventName, GATrackingEventType} from '../../constants';

export class GATrackingPdpWeeMoreDetailsClickEvent implements GATrackingEvent {
  constructor(private payload: any){}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.PdpWeeMoreDetailsInteraction;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.PdpWeeMoreDetailsInteraction,
      label: this.payload.label,
      gtmCustom: {
        action: this.payload.action,
        category: this.payload.category,
      }
    };
  }
}
